module.exports = __webpack_public_path__ + "fonts/94b249a3d82bb8a2a8792d48fe884e48.svg";